import axios, { AxiosError } from 'axios';
import { getRefreshAuthToken } from '../../services';
import {
  getCodeVerifierFromStorage,
  getRefreshTokenFromStorage,
  removeAuthTokenFromStorage,
  setToken,
} from '../auth';

let isAlreadyFetchingAccessToken = false;
let subscribers: Array<(accessToken: string | null) => void> = [];

export async function ResetTokenAndReattemptRequest(error: AxiosError): Promise<any> {
  try {
    const errorResponse = error.response;
    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber((accessToken) => {
        if (errorResponse && accessToken) {
          errorResponse.config.headers['access_token'] = accessToken;
          resolve(axios(errorResponse.config));
        }
      });
    });

    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;

      const refreshToken = getRefreshTokenFromStorage();
      const codeVerifier = getCodeVerifierFromStorage();

      if (!refreshToken || !codeVerifier) {
        throw new Error('No token found for refreshing');
      }

      const tokenData = await getRefreshAuthToken({ refreshToken, codeVerifier });

      if (!tokenData?.access_token) {
        throw new Error('Failed to refresh access token');
      }

      const { access_token, refresh_token } = tokenData;

      setToken(access_token, refresh_token, codeVerifier);

      isAlreadyFetchingAccessToken = false;
      onAccessTokenFetched(access_token);
    }

    return retryOriginalRequest;
  } catch (err) {
    isAlreadyFetchingAccessToken = false;
    clearAuthSessionAndRedirect();
    return Promise.reject(err);
  }
}

function onAccessTokenFetched(accessToken: string | null) {
  subscribers.forEach((callback) => callback(accessToken));
  subscribers = [];
}

function addSubscriber(callback: (accessToken: string | null) => void) {
  subscribers.push(callback);
}

export function clearAuthSessionAndRedirect() {
  removeAuthTokenFromStorage();
  if (typeof window !== 'undefined') {
    window.location.href = '/';
  }
}
